module.exports = __webpack_public_path__ + "static/media/logo-latinad-white.9992a650.png";